import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([
    { 
      title: "New Policy Review",
      message: "Policy #123 requires your review",
      time: "5 min ago",
      unread: true 
    },
    { 
      title: "Document Update",
      message: "Missing documents for Policy #456",
      time: "1 hour ago",
      unread: true 
    },
    { 
      title: "Approval Required",
      message: "Home insurance policy pending approval",
      time: "2 hours ago",
      unread: false 
    }
  ]);
  const [userProfile, setUserProfile] = useState({
    initials: 'JS',
    name: 'John Smith',
    role: 'Broker'
  });

  return (
    <AppContext.Provider value={{
      notifications,
      setNotifications,
      userProfile,
      setUserProfile
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext); 